import { ArrowDownRight, CircleCheck, MoveRight } from "lucide-react";
import { useState } from "react";
import { IMAGE_ASSETS } from "@/data/images";

const lines = ["Parts for the", "next ride.", "Priced for", "the workbench."];

export default function Hero({ onExplore, onAccount }) {
  const [tilt, setTilt] = useState({ x: 0, y: 0 });
  const handlePointerMove = (event) => {
    const rect = event.currentTarget.getBoundingClientRect();
    setTilt({ x: ((event.clientX - rect.left) / rect.width - 0.5) * 7, y: ((event.clientY - rect.top) / rect.height - 0.5) * -7 });
  };
  return (
    <section className="hero-section" id="top" data-testid="hero-section-container">
      <div className="hero-copy">
        <div className="eyebrow hero-eyebrow"><span className="live-dot" /> Batch 01 / Canada-ready catalogue</div>
        <h1 data-testid="hero-main-title">{lines.map((line, index) => <span className="hero-line-mask" key={line}><span style={{ animationDelay: `${index * 110}ms` }}>{line}</span></span>)}</h1>
        <p className="hero-intro">A considered catalogue of 125 master bicycle parts plus newly priced TJ brake records, from everyday leisure builds to race-day systems. Choose one piece or the quantity your workshop needs.</p>
        <div className="hero-actions">
          <button className="button button-primary" onClick={onExplore} data-testid="hero-explore-catalog-cta">Explore the catalogue <MoveRight size={18} /></button>
          <button className="button button-ghost" onClick={onAccount} data-testid="hero-create-account-cta">Create a free account <ArrowDownRight size={17} /></button>
        </div>
        <div className="hero-proof" data-testid="hero-proof-strip">
          <span><CircleCheck size={16} /> No account fee</span>
          <span><CircleCheck size={16} /> Single-part orders</span>
          <span><CircleCheck size={16} /> CAD pricing</span>
        </div>
      </div>
      <div className="hero-stage" onMouseMove={handlePointerMove} onMouseLeave={() => setTilt({ x: 0, y: 0 })} data-testid="hero-featured-parallax-component">
        <div className="stage-kicker"><span>Featured component / 001</span><span>Origin: Hebei → Canada</span></div>
        <div className="stage-frame">
          <div className="stage-grid" />
          <div className="stage-stamp">BPD<br /><small>DIRECT</small></div>
          <img className="hero-photo" src={IMAGE_ASSETS.chainring} alt="Bicycle drivetrain chainring component" style={{ transform: `translate3d(${tilt.x}px, ${tilt.y}px, 0) scale(1.04)` }} />
          <div className="stage-caption"><span>Drivetrain / chainrings</span><strong>Precision where it counts.</strong></div>
        </div>
        <div className="hero-telemetry">
          <div><span>Direct price</span><strong>From $4.50 CAD</strong></div>
          <div><span>SKU range</span><strong>001—135</strong></div>
          <div><span>Order size</span><strong>1 → desired</strong></div>
        </div>
      </div>
    </section>
  );
}
